<div class="client-list page">
  <app-tabs [tabs]="tabs" [activeTab]="activeTab" (tabChange)="setActiveTab($event)" />
  <div class="heading-wrapper">
    <h4>{{ (activeTab === 'individual' ? 'pages.client.individualTitle' : 'pages.client.organizationTitle') | translate }}</h4>
    <div class="actions">
      <button class="primary add-btn" (click)="navigateToAddPage()">
        <img src="assets/images/add-icon-white.svg" alt="add-icon-white.svg" />
        {{ (activeTab === 'individual' ? 'pages.client.addClient' : 'pages.client.addOrganization') | translate }}
      </button>
      <button
        class="secondary download-excel"
        [disabled]="isExcelDownloading"
        [ngClass]="{ downloading: isExcelDownloading }"
        (click)="getExcelFile()">
        @if (!isExcelDownloading) {
          <img src="assets/images/download-excel.svg" alt="download-excel.svg" />
          {{ 'pages.user.saveExcel' | translate }}
        } @else {
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
        }
      </button>
    </div>
  </div>
  @if (activeTab === 'individual') {
    <app-table
      [columns]="individualTableColumns"
      [endpoint]="clientApiPath"
      [flatTopBorder]="true"
      sortBy="createdOn"
      [sortDirection]="'desc'"
      type="clientList"
      [defaultFilters]="individualDefaultFilters"
      viewEntryPath="/klients/{id}" />
  } @else {
    <app-table
      [columns]="organizationTableColumns"
      [endpoint]="legalEntityApiPath"
      [flatTopBorder]="true"
      sortBy="createdOn"
      [sortDirection]="'desc'"
      type="orgClientList"
      viewEntryPath="/juridiska-persona/{id}" />
  }
</div>
